// tabs
export const AD_PERFORMANCE_TAB = 'adPerformance'
export const RETAIL_PERFORMANCE_TAB = 'retailPerformance'
export const BUY_BOX_PERFORMANCE_TAB = 'buyBoxPerformance'

export type ProductCatalogTabId =
    | typeof AD_PERFORMANCE_TAB
    | typeof RETAIL_PERFORMANCE_TAB
    | typeof BUY_BOX_PERFORMANCE_TAB
